import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { catchHttpError } from '../utils/catch-http-error';
import {
    LoadPlanByTaxIdAction,
    LoadPlanByTaxIdFailureAction,
    LoadPlanByTaxIdSuccessAction,
    PlanActionTypes
} from './actions';
import { PlanService } from './service';

@Injectable()
export class PlanEffects {
    private actions$ = inject(Actions);
    private service = inject(PlanService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    loadPlanByTaxId$ = createEffect(() =>
        this.actions$.pipe(
            ofType<LoadPlanByTaxIdAction>(PlanActionTypes.LOAD_PLAN_BY_TAX_ID),
            switchMap(action =>
                this.service.getPlanByTaxId(action.payload.taxId, action.payload.planNumber).pipe(
                    map(plan => new LoadPlanByTaxIdSuccessAction({ plan: plan })),
                    catchHttpError(error => of(new LoadPlanByTaxIdFailureAction({ error: error })))
                )
            )
        )
    );
}
